import { formSubmissionDuckCreator } from 'axl-ducks';

import { vdpDuckPreset } from '@/ducks/presets/index.js';

export default formSubmissionDuckCreator({
    ...vdpDuckPreset,
    store: 'fraudReport',
});
